'use client'

import { Spacer } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { SeparatedList } from '@marketplace-web/common-components/separated-list-ui'

import FactBlock from './FactBlock'
import ResponsiveWrapper from '../ReponsiveWrapper'

type Props = {
  showPro: boolean
}

const TrustSection = ({ showPro }: Props) => {
  const translate = useTranslate('trust_and_safety')
  const translatePro = useTranslate('trust_and_safety_pro')

  return (
    <SeparatedList
      separator={
        <ResponsiveWrapper
          mobile={<Spacer size={Spacer.Size.X2Large} />}
          desktop={<Spacer size={Spacer.Size.X4Large} />}
        />
      }
    >
      <FactBlock
        icon="communicate"
        title={translate('communicate_title')}
        body={translate('communicate_body')}
      />
      <FactBlock icon="review" title={translate('review_title')} body={translate('review_body')} />
      <FactBlock
        icon="verify"
        title={translate('verified_title')}
        body={translate('verified_body')}
      />
      <FactBlock
        icon="proactive"
        title={showPro ? translatePro('proactive_title') : translate('proactive_title')}
        body={showPro ? translatePro('proactive_body') : translate('proactive_body')}
      />
    </SeparatedList>
  )
}

export default TrustSection
